import React, { useState, useEffect } from "react";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { Button, Container, Input } from "reactstrap";
import config from "../../config.json";
import { HiOutlineMinus, HiOutlinePlus } from "react-icons/hi";
import "./style.css";
import LoadingSpinner from "../../components/common/Admin/common/LoadingSpinner";
import { Link, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { GlobalContext } from "../../components/layouts/UserLayout";
import {
  getServices,
  postServices,
  removeServices,
  updateServices,
} from "../../apiServices/apiServices";
import toast from "react-hot-toast";
import NoInternetComp from "../../components/common/InternetConnetction/NoInternetComp";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactSelect from "react-select";
import { motion } from "framer-motion";

const colorStyles = {
  control: (styles, state) => ({
    ...styles,
    //   backgroundColor: "#c5d3e380",
    // border: "1px solid #800000",
    border: `1px solid ${
      state.selectProps["data-error"] ? "#dc2626" : "#800000"
    }`,
    boxShadow: state.selectProps["data-error"]
      ? "0 0 0 2px rgba(220, 38, 38, 0.2)"
      : "none",
    marginBottom: "0",
    marginTop: "0",
    outline: "none",
    // padding: "0.25rem",
    padding: "2px",
    // boxShadow: "none",
    borderRadius: "8px",
    // "&:hover": {
    //   border: "1px solid #800000",
    // },
    "&:hover": {
      borderColor: state.selectProps["data-error"] ? "#b91c1c" : "#800000",
    },
  }),
};

function CartPage() {
  const access_token = localStorage.getItem("user-access-token");
  const ship_rocket_access_token = localStorage.getItem(
    "user-shiprocket-access-token"
  );
  const [data, setData] = useState([]);
  const [expectedDate, setExpectedDate] = useState();
  const [selectedAddress, setSelectedAddress] = useState();
  const [addressError, setAddressError] = useState(false);
  const [addressShakeKey, setAddressShakeKey] = useState(0);
  const [referal, setReferal] = useState("");
  const url = config.url;
  const [isLoading, setIsLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const global_context = useContext(GlobalContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (access_token && navigator.onLine) {
      fetchCartData(true);
      fetchDeliveryAddress();
    }

    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [navigator]);

  const fetchDeliveryAddress = async () => {
    try {
      const res = await getServices(`/api/address/list_address`, access_token);

      if (res.responseCode === 200) {
        setAddressList(res.responseData);
        // setSelectedAddress(res.responseData[0].address_id);
      } else {
        setAddressList([]);
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchCartData = async (load) => {
    setIsLoading(load);
    try {
      const res = await getServices(
        `/api/cart/list_cart`,
        access_token,
        ship_rocket_access_token
      );
      setIsLoading(false);
      if (res.responseCode === 200) {
        setData(res.responseData);
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error(error);
    }
  };

  const handleQuantityIncrease = async (data) => {
    const increasedQuantity = data.product_qty + 1;

    try {
      const res = await updateServices(
        `/api/cart/update_cart/${data.cart_id}`,
        access_token,
        { product_qty: increasedQuantity.toString() }
      );
      if (res.responseCode === 200) {
        fetchCartData(false);
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleQuantityDecrease = async (data) => {
    const decreasedQuantity = data.product_qty - 1;

    try {
      const res = await updateServices(
        `/api/cart/update_cart/${data.cart_id}`,
        access_token,
        { product_qty: decreasedQuantity.toString() }
      );
      if (res.responseCode === 200) {
        fetchCartData(false);
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleCartDelete = async (cart_id) => {
    if (window.confirm("Are you sure you want to remove this item?")) {
      try {
        const res = await removeServices(
          `/api/cart/remove_cart/${cart_id}`,
          access_token
        );
        if (res.responseCode === 200) {
          fetchCartData(true);
          global_context.fetchCartData();
        } else {
          toast.error(res.responseMessage);
        }
      } catch (error) {
        toast.error(error.message);
      }
    }
  };

  const handlePlaceOrder = () => {
    navigate("/manage_address", { state: { is_cart: 1 } });
  };

  const handleRequestBulkOrder = async () => {
    setBtnLoading(true);

    if (!selectedAddress) {
      setBtnLoading(false);
      setAddressError(true);
      setAddressShakeKey((prev) => prev + 1);
      toast.error("Please select a delivery address");
      return;
    }

    try {
      const res = await postServices(
        `/api/orders/make_order`,
        access_token,
        {
          expected_date: expectedDate,
          referral_code: referal,
          address_id: selectedAddress?.value,
        }
        // ship_rocket_access_token
      );

      setBtnLoading(false);
      if (res.responseCode === 200) {
        navigate("/manage_cart/successfully_requested_to_bulk_order");
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      setBtnLoading(false);
      toast.error(error);
    }
  };

  return (
    <>
      <Container className="pt-2">
        {navigator.onLine ? (
          <Container>
            {access_token ? (
              <Container>
                {isLoading ? (
                  <Container className="flex items-center justify-center h-[66vh]">
                    <LoadingSpinner />
                  </Container>
                ) : (
                  <Container className="p-4 sm:px-8">
                    {data.count <= 0 ? (
                      <Container className="flex justify-center items-center h-[65vh] flex-col">
                        <p className="font-semibold mb-4">Yout Cart is empty</p>
                        <Link to="/">
                          <Button className="bg-[#800000] font-semibold text-white py-2 px-10 rounded active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out">
                            Shop Now
                          </Button>
                        </Link>
                      </Container>
                    ) : (
                      <Container className="cart-details-cards min-h-[55vh]">
                        <Container className="cart-details-first-card sm:pr-2 mb-4">
                          <Container className="p-2 sm:p-5 bg-white rounded-xl shadow-lg sticky top-28 bottom-0">
                            <Container className="flex flex-col gap-4 items-end">
                              {data.data?.map((item, i) => (
                                <Container
                                  className="bg-[#8000000f] w-full sm:col-span-2 px-4 py-2 flex gap-2 items- relative rounded-md"
                                  key={i}
                                >
                                  <Link
                                    to="/product_details"
                                    state={{
                                      product_id: item.product.product_id,
                                    }}
                                  >
                                    <img
                                      src={
                                        url +
                                        item.product.variationInfo.image[0]
                                      }
                                      alt="cart product preview"
                                      className="aspect-square w-20 sm:w-32 object-cover"
                                    />
                                  </Link>
                                  <Container>
                                    <Link
                                      to="/product_details"
                                      state={{
                                        product_id: item.product.product_id,
                                      }}
                                    >
                                      <p className="font-semibold text-sm sm:text-base capitalize">
                                        {item.product.product_name}
                                      </p>
                                      <p className="text-xs sm:text-sm text-[#626262]">
                                        {item.product.colorInfo.color ?? "-"} |{" "}
                                        {item.brandingInfo.name ?? "-"} |{" "}
                                        {
                                          item.product?.variationInfo
                                            ?.breadth_in_mm
                                        }{" "}
                                        x{" "}
                                        {
                                          item.product?.variationInfo
                                            ?.length_in_mm
                                        }
                                      </p>
                                      {/* {item.product.variationInfo?.brandings
                                        ?.length > 0 && (
                                        <p className="text-xs sm:text-sm text-[#626262]">
                                          <span className="font-semibold">
                                            Brandings:{" "}
                                          </span>
                                          {item.product.variationInfo?.brandings
                                            .map((brand) => brand.name)
                                            .join(", ")}
                                        </p>
                                      )} */}
                                      {/* <p className="text-xs sm:text-sm text-[#868686]">
                                        {item.product.variationInfo.variation}{" "}
                                        inch
                                      </p> */}
                                    </Link>

                                    {/* <Container className="mt-1">
                                      <p className="text-red-600 bg-red-100 text-xs sm:text-sm px-4 py-1 rounded-full w-max">
                                        Total pieces of product: {item.moq ?? 1}
                                      </p>
                                    </Container> */}

                                    <Container className="text-sm sm:text-base flex">
                                      <Container
                                        className="flex items-center p-1 justify-between rounded-lg"
                                        style={{
                                          fontFamily: "Poppins",
                                        }}
                                      >
                                        <Button
                                          className="inline-flex items-center justify-center border-none outline-none text-center p-1 text-lg disabled:text-gray-400 disabled:cursor-not-allowed"
                                          disabled={
                                            item.product_qty <= 1 ? true : false
                                          }
                                          onClick={() =>
                                            handleQuantityDecrease(item)
                                          }
                                        >
                                          <HiOutlineMinus />
                                        </Button>
                                        <p className="py-1 px-3">{item.moq}</p>
                                        <Button
                                          className="inline-flex items-center justify-center border-none outline-none text-center p-1 text-lg disabled:text-gray-400 disabled:cursor-not-allowed"
                                          onClick={() =>
                                            handleQuantityIncrease(item)
                                          }
                                        >
                                          <HiOutlinePlus />
                                        </Button>
                                      </Container>
                                    </Container>
                                    <Container className="flex gap-2 text-sm sm:text-base items-start">
                                      <p className="font-semibold">
                                        ₹{" "}
                                        {item.product?.variationInfo
                                          ?.sales_price > 0
                                          ? Number(
                                              item.product?.variationInfo
                                                ?.sales_price
                                            ).toLocaleString("en-IN")
                                          : Number(
                                              item.product?.variationInfo?.price
                                            ).toLocaleString("en-IN")}
                                      </p>
                                      {item.product?.variationInfo
                                        ?.sales_price > 0 && (
                                        <p className="line-through text-xs text-[#757575]">
                                          ₹{" "}
                                          {item.product?.variationInfo
                                            ?.sales_price > 0
                                            ? Number(
                                                item.product?.variationInfo
                                                  ?.price
                                              ).toLocaleString("en-IN")
                                            : null}
                                        </p>
                                      )}
                                      {item.product.variationInfo.offer_value >
                                        0 && (
                                        <p className="font-medium">
                                          {item.product.variationInfo
                                            .offer_value + "% OFF"}
                                        </p>
                                      )}
                                    </Container>

                                    {/* <Container className="mt-2 bg-green-100 py-2 px-4 rounded-lg w-fit flex flex-col gap-1">
                                      <p className="text-xs sm:text-sm font-medium text-green-800 w-fit">
                                        Total MRP:{" "}
                                        {Number(
                                          item.product.variationInfo.price
                                        ).toLocaleString("en-IN") +
                                          " x " +
                                          item.moq?.toString() +
                                          " = " +
                                          Number(
                                            item.product.variationInfo.price *
                                              item.moq
                                          ).toLocaleString("en-IN")}
                                      </p>
                                      <p className="text-xs sm:text-sm font-medium text-green-800 w-fit">
                                        Total Amount:{" "}
                                        {Number(
                                          item.product.variationInfo.sales_price
                                        ).toLocaleString("en-IN") +
                                          " x " +
                                          item.moq?.toString() +
                                          " = " +
                                          Number(
                                            item.product.variationInfo
                                              .sales_price * item.moq
                                          ).toLocaleString("en-IN")}
                                      </p>
                                    </Container> */}
                                  </Container>

                                  <Container className="absolute right-3 bottom-3 flex gap-3">
                                    <MdOutlineDeleteOutline
                                      className="text-3xl sm:text-4xl bg-[#800000] text-white p-1 rounded-full cursor-pointer"
                                      onClick={() =>
                                        handleCartDelete(item.cart_id)
                                      }
                                    />
                                  </Container>
                                </Container>
                              ))}
                            </Container>
                          </Container>
                        </Container>
                        <Container className="cart-details-second-card">
                          <Container className="lg:mt-0 p-5 shadow-lg mb-6 sm:mb-3 bg-[#8000000f] mt-4 sm:col-span-1 w-full px-4 py-2 flex flex-col gap-2 rounded-md sticky top-28 bottom-0">
                            <p className="font-semibold text-base mb-3">
                              Price Details
                            </p>
                            <Container className="flex justify-between text-sm">
                              <div>
                                <p>Total MRP</p>
                                <p>{}</p>
                              </div>
                              <p className="font-semibold">
                                ₹
                                {Number(data?.totalMRP).toLocaleString("en-IN")}
                              </p>
                            </Container>
                            <Container className="flex justify-between text-sm">
                              <p>Discount MRP</p>
                              <p className="font-semibold">
                                -₹
                                {Number(data.discountAmt).toLocaleString(
                                  "en-IN"
                                )}
                              </p>
                            </Container>
                            {/* <Container className="flex justify-between text-sm">
                              <p>Shipping Fee</p>
                              <p className="font-semibold">
                                Calculated at next step
                              </p>
                            </Container> */}
                            <hr className="border border-[#800000] my-2" />
                            <Container className="flex justify-between font-semibold">
                              <p>Total Amount</p>
                              <p>
                                ₹
                                {Number(data.totalPayableAmt).toLocaleString(
                                  "en-IN"
                                )}
                              </p>
                            </Container>
                            {/* <Button
                              className="w-full bg-[#800000] my-2 py-2 rounded-xl uppercase text-white font-semibold active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
                              onClick={handlePlaceOrder}
                            >
                              Place order
                            </Button> */}

                            <div className="mt-4">
                              <p className="mb-1 text-sm">
                                Select delivery address{" "}
                                <span className="text-red-700">*</span>
                              </p>
                              <motion.div
                                key={addressShakeKey}
                                initial={addressError ? { x: 0 } : false}
                                animate={
                                  addressError
                                    ? { x: [0, -6, 6, -4, 4, -2, 2, 0] }
                                    : { x: 0 }
                                }
                                transition={{ duration: 0.35 }}
                              >
                                <ReactSelect
                                  options={addressList.map((address) => {
                                    return {
                                      value: address.address_id,
                                      label:
                                        address.name +
                                        ", " +
                                        address.area +
                                        ", " +
                                        address.town +
                                        " - " +
                                        address.save_address_as,
                                    };
                                  })}
                                  onChange={(e) => {
                                    setSelectedAddress(e);
                                    if (e) setAddressError(false);
                                  }}
                                  data-error={addressError ? "true" : ""}
                                  placeholder="Select delivery address"
                                  className="text-sm outline-[#800000]"
                                  styles={colorStyles}
                                  isClearable
                                  required
                                />
                              </motion.div>
                              <p className="text-xs mt-[2px]">
                                Want packages delivered elsewhere? Let's{" "}
                                <Link
                                  to={"/manage_address"}
                                  state={{ is_bulk: 1 }}
                                  className="text-[#800000] font-medium"
                                >
                                  add another address
                                </Link>
                                !
                              </p>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 items-start mt-1">
                              <p className="mb-1 md:mb-0 text-sm">
                                Requested delivery date{" "}
                                <span className="text-xs">(Optional)</span>
                              </p>
                              <div className="w-full">
                                <DatePicker
                                  selected={expectedDate}
                                  onChange={(date) => setExpectedDate(date)}
                                  minDate={new Date()}
                                  className="border border-[#800000] outline-[#800000] rounded-lg py-1 px-3 w-full"
                                  wrapperClassName="w-full"
                                />
                              </div>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 items-start mt-1">
                              <p className="mb-1 md:mb-0 text-sm">
                                Referral code{" "}
                                <span className="text-xs">(Optional)</span>
                              </p>
                              <div className="w-full">
                                <Input
                                  type="text"
                                  name="referral"
                                  onChange={(e) => setReferal(e.target.value)}
                                  value={referal}
                                  placeholder="Referral code"
                                  className="border border-[#800000] outline-[#800000] rounded-lg py-1 px-3 w-full"
                                  required
                                />
                              </div>
                            </div>
                            <p className="text-sm leading-relaxed ">
                              <span className="font-bold text-black text-xs">
                                NOTE:
                              </span>
                              <span className="text-[#800000] text-xs ml-1 font-normal">
                                The above pricing is inclusive of GST. Branding,
                                packaging, transportation and applicable taxes
                                will be charged at actuals and added to the
                                final invoice.
                              </span>
                            </p>

                            {!btnLoading ? (
                              <Button
                                className="w-full bg-[#800000] my-2 py-2 rounded-xl text-white font-semibold active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out"
                                onClick={handleRequestBulkOrder}
                              >
                                Request Bulk Price <br />
                                <span className="text-sm font-medium">
                                  (No obligation to purchase)
                                </span>
                              </Button>
                            ) : (
                              <Button
                                disabled
                                className="w-full disabled:bg-[#8000006c] disabled:cursor-not-allowed my-2 py-2 rounded-xl text-white font-semibold"
                              >
                                Loading...
                              </Button>
                            )}
                          </Container>
                        </Container>
                      </Container>
                    )}
                  </Container>
                )}
              </Container>
            ) : (
              <Container className="flex justify-center items-center h-[65vh] flex-col">
                <p className="font-semibold mb-4 text-center">
                  Register Now to avail your discount on Bulk Gifting
                </p>
                <Link to="/login">
                  <Button className="bg-[#800000] font-semibold text-white py-2 px-10 rounded active:scale-[.98] active:duration-75 transition-all hover:scale-[1.01] ease-in-out">
                    Login
                  </Button>
                </Link>
              </Container>
            )}
          </Container>
        ) : (
          <Container className="min-h-[65vh] flex flex-col justify-center items-center">
            <NoInternetComp />
          </Container>
        )}
      </Container>
    </>
  );
}

export default CartPage;
